<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-6">
        <BreadCrumb :page="page" />
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-end">
              <ActionButton
                variant="outline-success mr-2"
                i="fas fa-arrow-circle-left"
                :text="
                  `${fromRoute.from != null ? fromRoute.from : 'Regresar'}`
                "
                @click="navigate"
              />
              <ActionButton
                v-if="isEnabled"
                :class="!isEnabled ? 'disabled-page' : ''"
                type="submit"
                variant="success mr-2"
                i="fas fa-save"
                @click="handleSubmit"
              >
                Guardar
              </ActionButton>
              <ActionButton
                v-if="save"
                variant="success"
                i="fas fa-print"
                @click="print"
              >
                Imprimir
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Separator -->
    <div class="col-12 dropdown-divider pb-4 w-100" />

    <!-- Informacion de la Determinacion -->
    <div class="col-12">
      <SectionTitle has-line content="Información de la Determinación" />
    </div>
    <div class="w-100" :class="!isEnabled ? 'wrapper-block' : ''">
      <div :class="!isEnabled ? 'disabled-page' : ''">
        <div class="col-12">
          <EligibilityDetermination
            v-model="generalEligibilityDetermination"
            :disabled="!isEnabled"
            @getRef="getObserver"
          />
        </div>

        <!-- Comentario -->
        <div class="col-12">
          <SectionTitle has-line content="Comentario" />
        </div>

        <div class="col-12">
          <ValidationObserver ref="observertxt">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              mode="eager"
            >
              <CustomTextArea
                v-show="true"
                v-model="evaluationDescription"
                :maxlength="3000"
                :rows="5"
                placeholder="Escribir comentario..."
                :error="errors[0]"
                :custom-error-msg="errorMsgs.comment"
              />
            </ValidationProvider>
          </ValidationObserver>
        </div>

        <!-- Separator -->
        <div class="dropdown-divider mt-0 pb-4 w-100" />

        <!-- Documentos de Respaldo al Proceso de Determinacion -->
        <div class="col-12">
          <SectionTitle
            has-line
            content="Documentos de Respaldo al Proceso de Determinación"
          />
        </div>

        <!--Documento de Respaldo-->
        <div class="col-12">
          <BackupDocument @files="gettingBackupDocument" />
        </div>

        <!-- Informacion de Evaluaciones -->
        <div class="col-12">
          <SectionTitle has-line content="Información de Evaluaciones" />
        </div>

        <div class="col-12">
          <ErrorComponent
            v-if="validate && !hasEvaluationSelected"
            message="Es necesario que seleccione al menos una evaluación durante la discusión."
            variant="withoutspacing"
          />

          <ErrorComponent
            v-if="validate && hasInvalidSelectedEvaluation"
            message="Es necesario que acepte o rechaze las evaluaciones seleccionadas."
            variant="withoutspacing"
          />

          <ErrorComponent
            v-if="
              validate && hasEvaluationSelected && existInvalidEvaluationReject
            "
            message="Es necesario documentar la razón por la que no se aceptó la evaluacion(es) seleccionada(s)."
            variant="withoutspacing"
          />

          <ErrorComponent
            v-if="validate && !allEvaluationsApprovedOrRejected"
            message="Favor seleccionar todas las evaluaciones en la lista o remover las evaluaciones no seleccionadas."
            variant="withoutspacing"
          />

          <div class="mx-3">
            <ValidationObserver ref="evaluationInformation">
              <EvaluationInformation
                v-model="evaluationInformationLayout"
                :has-option-determinate="
                  generalEligibilityDetermination.changeImpediment
                "
                :evaluation-saved="!isEnabled"
                :get-evaluations="this.getEvaluationInfoAndAvailable"
                @evaluationsModalSaveHandler="
                  this.selectedEvaluationsModalSaveHandler
                "
                @addPreviousEvaluation="showAddPreviousModal"
              />
            </ValidationObserver>
            <AddPreviousEvaluationsModal
              v-if="openModal"
              @state="
                (state) => {
                  openModal = state;
                }
              "
              @refresh="({ id }) => this.loadEvaluations(id)"
            />
          </div>

          <Error
            v-if="serverEvaluationErrorMessage != null"
            variant="no-border error-margin-left mb-2 custom-errors-list"
            :message="serverEvaluationErrorMessage"
          />
        </div>

        <!-- Determinación de Elegibilidad Triannual -->
        <div
          v-if="generalEligibilityDetermination.changeImpediment"
          class="row mb-4"
        >
          <div class="col">
            <EligibilityDeterminationTriannual
              ref="triannualEvaluation"
              v-model="eligibilityDeterminationDataTriannual"
              :called-from="'Evaluations'"
              :date-eligibility="
                generalEligibilityDetermination.academicyearfordate != null
                  ? generalEligibilityDetermination.academicyearfordate
                  : new Date()
              "
              :date-registration="model.registrationDate"
              has-validation-pending
              :show-intervention-questionnaire="false"
              @getRef="getObserver"
              @on-eligibility-data-changed="onEligibilityDataChanged"
            />
          </div>

          <div v-if="additionalQuestionsFlag" class="mt-4 col-12">
            <div class="col">
              <additional-questions
                ref="additionalQuestions"
                :academic-year="academicYear"
                class="mb-4"
              />
            </div>
          </div>
        </div>

        <!-- Firma de Participantes -->
        <div class="col-12">
          <SectionTitle has-line content="Firma de Participantes" />
        </div>

        <div class="col-12">
          <ValidationObserver ref="signatureObserver" slim>
            <Tab9ParticipantSignatures
              ref="participantSignatures"
              :key="componentKey"
              :value="signatureList"
              :options="availableSignatureOptions"
              :is-draft="true"
              :participation-types="participationTypeList"
              :alternate-participations="alternateParticipationTypeList"
              @addSignature="addSignature()"
              @deleteSignature="deleteSignature"
            />
          </ValidationObserver>
        </div>

        <CustomHR variant="none" />
        <CustomHR variant="success" />

        <footer-buttons>
          <div slot="buttons" class="mv">
            <ActionButton
              v-if="isEnabled"
              variant="success"
              i="fas fa-save"
              type="submit"
              @click="handleSubmit"
            >
              Guardar
            </ActionButton>
          </div>
        </footer-buttons>
      </div>
    </div>
  </div>
</template>

<script>
import { discussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';
import { SectionTitle } from '@/components/pei/shared';
import store from '@/store/index';
import BreadCrumb from '@/components/common/page/TitleBreadcrumb';
import EligibilityDetermination from '@/components/studentEvaluation/EligibilityDetermination';
import BackupDocument from '@/components/studentEvaluation/BackupDocument';
// import EvaluationInformationLayout from "@/components/studentEvaluation/EvaluationInformationLayout";
import EvaluationInformation from '@/components/studentEvaluation/EvaluationInformation';
import AddPreviousEvaluationsModal from '@/components/studentEvaluation/AddPreviousEvaluationsModal';
import ActionButton from '@/components/common/ActionButton';
import CustomHR from '@/components/common/page/CustomHR';
import CustomTextArea from '@/components/common/CustomTextArea';
import ErrorComponent from '@/components/common/Error';
import objectToFormData from 'object-to-formdata';
import loading from '@/mixin/loading.mixin';
import { ValidationObserver } from 'vee-validate';
import resourcesService from '@/services/resources.js';
import FooterButtons from '@/components/common/FooterButtons';
import placementCommitteeCategory from '@/utils/constants/student/placementCommitteeCategory';
import EligibilityDeterminationTriannual from '@/components/triannualDeterminationProcess/components/EligibilityDetermination';
import alertMixin from '@/mixin/alert.mixin';
import Error from '@/components/common/Error';
import Tab9ParticipantSignatures from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures';
import signatureService from '@/modules/common/signature.api';
import studentEvaluationService from '@/modules/student-evaluations/api.js';
import reportService from '@/services/report';
import AdditionalQuestions from '.././components/AdditionalQuestions';
export default {
  prop: {
    throwSave: {
      type: Boolean,
      default: false,
    },
    evaluationId: {
      type: Number,
      default: 0,
    },
  },
  mixins: [loading, alertMixin],
  components: {
    BreadCrumb,
    EligibilityDetermination,
    BackupDocument,
    // EvaluationInformationLayout,
    EvaluationInformation,
    AddPreviousEvaluationsModal,
    ActionButton,
    CustomHR,
    CustomTextArea,
    ValidationObserver,
    ErrorComponent,
    FooterButtons,
    SectionTitle,
    EligibilityDeterminationTriannual,
    Error,
    Tab9ParticipantSignatures,
    AdditionalQuestions,
  },
  data() {
    return {
      additionalQuestionsFlag: false,
      elegibilityInfo: null,
      page: {
        icon: 'fas fa-user-circle',
        title: 'Proceso de Discusión de Evaluación en COMPU',
        routes: ['Inicio', 'Estudiante', 'Discusión de Evaluaciones'],
      },
      places: [
        { signatureGroupId: 1 },
        { signatureGroupId: 5 },
        { signatureGroupId: 6 },
      ],
      signatures: [],
      placementCommitteeCategoryId:
        placementCommitteeCategory.EvaluacionAdicional,
      evaluationDateTypeCode: 313,
      disabledDatesAfter: null,
      errorMsgs: {
        comment: '',
      },
      // Submit Data.
      evaluationDescription: null,
      eligibilityDeterminationData: {
        academicYearId: null,
        academicYearDesc: null,
        evaluationDate: null,
        impedimentChangeFlag: null,
      },
      backupDocumentsData: {
        files: [],
        types: [],
      },
      // Flags.
      getEligibilityDetermination: false,
      // Validar propiedades fuera de VeeValidate.
      validate: false,
      // Evento para guardar.
      throwSave: false,
      evaluationId: 0,
      // Flag para indicar que se ha guardado.
      save: false,
      observers: {},
      isEnabled: true,
      resources: [],
      //General Determination Information Section I
      generalEligibilityDetermination: {
        changeImpediment: null,
        academicYearId: null,
        academicyearfordate: null,
        academicYearDesc: null,
        // evaluationDate: null, // =academicyearfordate
      },
      // End General Determination Informtion
      model: {},
      elegibilityDetermination: {
        show: false,
        eligibilityInfo: {},
        data: null,
        get: false,
      },
      serverEvaluationErrorMessage: null,
      HasValidEvaluationSelection: false,
      evaluationInformation: {
        // Validations.
        evaluationAcceptedAndDetermined: true,
        allEvaluationsAcceptedOrRejected: false,
        // Variable to save component data.
        data: null,
        // Flags getting event.
        get: false,
        getValidation: false,
        evaluationInformationExternalData: null,
      },
      selectedAllEvaluations: true,
      selectedEvaluationModels: [],
      //signature Managment properties
      signatureCounter: 0,
      signatureList: [],
      componentKey: 0,
      availableSignatureOptions: [],
      participationTypeList: [],
      alternateParticipationTypeList: [],

      //Evaluation Information for Evaluation Information Layout
      evaluationInformationLayout: {
        evaluationsAddedList: [],
        availables: [],
        evaluationInformationData: [],
      },
      //Add Previous Evaluations
      openModal: false,
      evaluationDateId: null,
      placementCommitteeId: null,

      eligibilityDeterminationDataTriannual: {
        dateEligibility: null, // type: [Date, String],
        isElegibility: null,
        comments: '', //String
        meetingQty: null, //Object
        isHealthSpecialistNecessary: null, //Bool
        participatedSpecialist: null, //Bool
        certification: null,
        impediment: null,
        severity: null,
        disorders: null,
        partialHearing: null,
        //Multiple
        impedimentMultiple: {
          impediment: null,
          selectedItems: [],
        }, //Object
        severityMultiple: null,
        disordersMultiple: null, //Object
        partialHearingMultiple: null, //Object
      },
    };
  },

  async mounted() {
    this.resources = await resourcesService.LoadValidationMessages([
      '17306',
      '22124',
      '150',
      'R90006',
      '22144',
      '22145',
      '22147',
      '1908031',
    ]);

    this.errorMsgs.comment = this.resources['17306'];

    if (this.fromRoute.headerTitle != undefined) {
      this.page.title = this.fromRoute.headerTitle;
    }
    //Load all Signatures
    await this.getParticipationTypeList();
    await this.getAlternateParticipationTypeList();
    //Get Evaluations
    await this.loadEvaluations();

    if (this.fromRoute.evaluationId > 0) {
      await this.GetEvaluationDiscussion(this.fromRoute.evaluationId);
    }

    await this.setSignatureConfig();
  },
  methods: {
    async loadEvaluations(addedRecentlyId = null) {
      const _excludedList = this.evaluationInformationLayout.availables;
      let _addedList = this.evaluationInformationLayout.evaluationsAddedList;

      if (addedRecentlyId > 0) _addedList.push(addedRecentlyId);

      if (_addedList && _addedList.length > 0)
        _addedList = _addedList.map((x) => ({ value: x }));

      await this.getEvaluationInformation(_addedList, _excludedList);
      await this.getAvailablesEvaluations();
    },
    //Show Modal
    showAddPreviousModal() {
      this.openModal = true;
    },
    getObserver(id, observer) {
      this.observers = {
        ...this.observers,
        [id]: observer,
      };
    },
    async GetEvaluationDiscussion(evaluationId) {
      await this.$ApiGet(
        `/api/studentevaluation/studentevaluationdiscussiondetail/${evaluationId}`
      )
        .then((res) => {
          this.save = true;
          this.isEnabled = false;
          let placementCommittee = res.data.placementCommittee;
          this.placementCommitteeId =
            res.data.placementCommittee.placementCommitteId;

          this.generalEligibilityDetermination = {
            changeImpediment: placementCommittee.impedimentChangeFlag ?? false,
            academicYearId: placementCommittee.academicYearId,
            academicyearfordate: new Date(placementCommittee.committeeDate),
            academicYearDesc: placementCommittee.academicYearDesc,
          };

          this.evaluationDescription = placementCommittee.committeeDescription;

          //Evaluations
          let selectedStudentEvaluation = [];
          res.data.elegibilityInfo.eligibilityEvaluationInfo.forEach((e) => {
            selectedStudentEvaluation.push(e.studentEvaluationId.toString());
          });

          this.evaluationInformationLayout.evaluationsAddedList = selectedStudentEvaluation;

          let evaluationAddedList = selectedStudentEvaluation.map((e) => ({
            value: e,
          }));

          this.getEvaluationInformation(evaluationAddedList);

          //signatures
          this.signatureList = [];
          this.elegibilityInfo.attendanceInfo =
            res.data.elegibilityInfo.attendanceInfo;
          res.data.elegibilityInfo.attendanceInfo.forEach((x) => {
            this.signatureList.push({
              signature: {
                positionId: {
                  signaturePositionId: parseInt(x.positionId ?? 0),
                },
                alternateId: {
                  id: parseInt(x.alternateParticipationType ?? 0),
                },
                participationId: { id: parseInt(x.participationType ?? 0) },
                name: x.fullName,
              },
              id: x.id,
              groupId: 0,
              isRequired: this.validate,
              isRemovable: true,
              isDisabled: false,
            });
          });
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async handleSubmit() {
      await this.ValidateEvaluationInformation();
      this.data = await this.generateData();

      let sectionElegibility = await this.observers.elegibility.validate();
      let sectionTxt = await this.$refs.observertxt.validate();
      let evaluationInformationSection = await this.$refs.evaluationInformation.validate();

      //Force rejectAccept
      evaluationInformationSection =
        this.hasEvaluationSelected &&
        this.allEvaluationsApprovedOrRejected &&
        !this.existInvalidEvaluationReject &&
        !this.hasInvalidSelectedEvaluation;

      //Force Signature Validation
      let isSignatureValid = true;
      for (let i = 0; i < this.signatureList.length; i++) {
        this.signatureList[i].isRequired = true;
      }
      isSignatureValid =
        !this.signatureList.filter(
          (f) =>
            (f.isRequired && f.signature.name == '') ||
            f.signature.positionId == undefined ||
            f.signature.participationId == undefined ||
            (f.signature.participationId == 1 &&
              f.participationId.alternateId == undefined)
        ).length > 0;

      var isAQValid =
        !this.generalEligibilityDetermination.changeImpediment ||
        !this.additionalQuestionsFlag ||
        this.$refs.additionalQuestions.isValid;
      if (
        sectionElegibility &&
        sectionTxt &&
        isSignatureValid &&
        evaluationInformationSection &&
        isAQValid
      ) {
        this.send();
      } else {
        this.incompleteInformation();
      }
    },
    // Validations
    async ValidateEvaluationInformation() {
      // Valido la lista de de evaluaciones.
      this.validate = true;
    },
    // Generate data for send.
    async generateData() {
      await this.generateEligibilityDetermination();
    },
    // Dispara evento para obtener datos del componente EligibilityDetermination.
    async generateEligibilityDetermination() {
      this.getEligibilityDetermination = true;
      // Espero a traermo los datos del $emit.
      await this.$nextTick();
      this.getEligibilityDetermination = false;
    },
    // Events Handlers
    // Datos de componente BackupDocument.
    gettingBackupDocument(data) {
      this.backupDocumentsData = data;
    },
    // Metodo para enviar info al backend
    async send() {
      const elegibilityInfo = {
        eligibilityEvaluationInfo: this.evaluationInformationLayout.evaluationInformationData.map(
          (obj) => ({
            ...obj,
            discussionStatusId: obj.isApprovedByParentFlag
              ? discussionStatuses.accepted
              : discussionStatuses.rejected,
          })
        ),
        attendanceInfo: this.getSignatureList(),
        ...this.eligibilityInfoModel,
      };
      this.validateEligibility(elegibilityInfo, async (status) => {
        const selectedEvaluations =
          this.evaluationInformationLayout?.evaluationInformationData ?? [];
        if (selectedEvaluations.length > 0) {
          const triannualEvaluationRef = this.$refs.triannualEvaluation || {};
          const isNotEligible =
            triannualEvaluationRef?.field?.radioElegibility?.model === false;
          if (isNotEligible) {
            let isConfirmed = await this.ShowCancelModal(
              'Confirmación',
              `<div class="mb-3"> Al continuar con esta acción, el estudiante cambiará a estatus Egreso. Esto dejará sin efecto lo siguiente:</div>
                <ul>
                  <li class="mb-2"> Cancelará los referidos activos de evaluaciones </li>
                  <li class="mb-2"> Cancelará los referidos de terapia cambiaran a estatus No Vigente: Egreso </li>
                  <li class="mb-2"> Los proveedores de servicios no podrán facturas servicios a partir de esta fecha. </li>
                  <li class="mb-2"> Cancelará la elegibilidad para las solicitudes de transportación escolar. </li>  
                </ul>
              `,
              'Si',
              'No'
            );

            if (!isConfirmed) {
              return;
            }
          }
        }
        if (status) {
          let data = this.getDataAsJson();

          new Promise((resolve) => {
            this.$ApiPost('/api/studentEvaluation/save', data)
              .then((res) => {
                resolve(res.data);
                this.save = true;
                this.isEnabled = false;
                this.ShowToast(
                  'Proceso exitoso',
                  'Su información ha sido guardada',
                  'success'
                );
                this.evaluationDateId = res.data.evaluationDateTransactionID;
                this.placementCommitteeId =
                  res.data.placementCommittee.placementCommitteId;
                store.dispatch('$_student/refreshStudentMainInfo');
              })
              .catch((err) => {
                this.incompleteInformation();
                // Some of the error messages must be displayed in a specific section
                this.handleEvaluationsAndElegibilityErrorResponse(
                  err.response.data
                );
              });
          });
          this.throwSave = false;
          this.validate = false;
        } else {
          this.ShowToast(
            'Información Incompleta',
            'Favor verificar y completar la información solicitada.',
            'error'
          );
        }
      });
    },
    async incompleteInformation() {
      this.ShowToast('Alerta', this.resources[1908031], 'error');
    },
    async validateEligibility(evalAndEligibilityInfo, callback) {
      let self = this;
      const changeImpediment = this.generalEligibilityDetermination
        .changeImpediment;
      let evaluationSectionIsValid = true;
      this.serverEvaluationErrorMessage = null;

      //generate evaluation validations
      await this.generateEvaluationInformationValidations();
      if (this.hasInvalidSelectedEvaluation) {
        callback(false);
      } else {
        if (changeImpediment === true) {
          const validationResult = await this.$ApiPost(
            `api/studentregistry/validate/${this.selectedStudentSieId}/evaluationsandeligibility`,
            evalAndEligibilityInfo || {}
          ).catch((err) => {
            evaluationSectionIsValid = false;
            self.handleEvaluationsAndElegibilityErrorResponse(
              err.response.data
            );
            callback(false);
          });
          if (validationResult) {
            if (evaluationSectionIsValid) {
              callback(true);
            }
          } else {
            callback(false);
          }
        } else {
          callback(true);
        }
      }
    },
    // Trigger event to get data from the EvaluationInformation validations component.
    async generateEvaluationInformationValidations() {
      this.evaluationInformation.getValidation = true;
      // Waiting for data $emit.
      await this.$nextTick();
      this.evaluationInformation.getValidation = false;
    },
    handleEvaluationsAndElegibilityErrorResponse(response) {
      switch (response.code) {
        case '22148':
        case '22149':
        case '22150':
        case '22146':
        case '22147':
          this.serverEvaluationErrorMessage = response.message;
          break;
        default:
          // The toastr must be always displaying 'incomplete data' even if this method is not executed.
          break;
      }
    },

    getDataAsJson() {
      let data = {
        studentSieid: this.$store.getters.SelectedStudent.studentId,
        academicYearId: this.generalEligibilityDetermination.academicYearId,
        academicYearDesc: this.generalEligibilityDetermination.academicYearDesc,
        evaluationDate: this.generalEligibilityDetermination
          .academicyearfordate,
        evaluationDateTypeCode: this.evaluationDateTypeCode,
        commentDescription: this.evaluationDescription,
        impedimentChangeFlag: this.generalEligibilityDetermination
          .changeImpediment,
        isSufficientFlag: this.generalEligibilityDetermination.changeImpediment
          ? '1'
          : '0',
        hasEligibilityFlag: this.generalEligibilityDetermination
          .changeImpediment
          ? true
          : false,
        elegibilityInfo: {
          eligibilityEvaluationInfo: this.evaluationInformationLayout.evaluationInformationData.map(
            (obj) => ({
              ...obj,
              discussionStatusId: obj.isApprovedByParentFlag
                ? discussionStatuses.accepted
                : discussionStatuses.rejected,
            })
          ),
          attendanceInfo: this.getSignatureList(),
          ...this.eligibilityInfoModel,
        },
        placementCommittee: {
          committeeDate: this.generalEligibilityDetermination
            .academicyearfordate,
          academicYearId: this.generalEligibilityDetermination.academicYearId,
          committeeDescription: this.evaluationDescription,
          placementCommitteeCategoryId: this.placementCommitteeCategoryId,
          impedimentChangeFlag: this.generalEligibilityDetermination
            .changeImpediment,
        },
      };

      if (this.backupDocumentsData.types.length > 0) {
        data.documentTypes = this.backupDocumentsData.types;
      }
      if (
        this.additionalQuestionsFlag &&
        this.generalEligibilityDetermination.changeImpediment
      ) {
        this.$refs.additionalQuestions.mapQuestionsAnswers();
        data.StudentExitAdditionalQuestions = this.$refs.additionalQuestions.PeiAdditionalQuestionsToDB;
      }
      let formData = objectToFormData(data, { indices: true });
      this.backupDocumentsData.files.map((file) => {
        formData.append(`documents`, file);
      });
      return formData;
    },
    onEvaluationDataChanged(data) {
      this.selectedAllEvaluations = data.selectedAllEvaluations;
      this.selectedEvaluationModels = data.evaluations;
    },
    goBack() {
      const self = this;
      self.$router.go(-1);
    },
    navigate() {
      if (this.fromRoute.toward != undefined) {
        this.$router.push({ ...this.fromRoute.toward });
      } else {
        this.goBack();
      }
    },
    //Signature Managment methods
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.validate,
        isRemovable: true,
        isDisabled: false,
      });
    },

    deleteSignature(id) {
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    //Mejora al control (usar v-model para evitar estos cambios)
    getBasicSignature(groupId) {
      let signature;
      if (this.elegibilityInfo != null) {
        signature = this.elegibilityInfo.attendanceInfo.find((x) =>
          this.availableSignatureOptions.some(
            (y) =>
              y.signatureGroupId == groupId &&
              y.signaturePositionId == x.positionId
          )
        );
      }

      if (signature != undefined) {
        return {
          id: signature.id,
          signature: {
            name: signature.fullName,
            positionId: { signaturePositionId: signature.positionId },
            participationId: { id: signature.participationTypeId },
            alternateId: { id: signature.alternateParticipationTypeId },
          },
          groupId: groupId,
          isRequired: this.validate,
          isRemovable: false,
          isDisabled: false,
        };
      } else {
        this.signatureCounter -= 1;
        return {
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: undefined,
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: groupId,
          isRequired: this.validate,
          isRemovable: false,
        };
      }
    },
    getSignatureList() {
      let self = this;
      let signatures = [];
      self.signatureList.forEach((x) => {
        let signInfo = {
          id: x.id,
          fullName: x.signature.name,
          positionId: x.signature.positionId?.signaturePositionId,
          participationType: x.signature.participationId?.id,
          alternateParticipationType: x.signature.alternateId
            ? x.signature.alternateId.id
            : undefined,
          IsRequired: !x.isRemovable,
        };
        signatures.push(signInfo);
      });
      return signatures;
    },
    async setSignatureConfig() {
      //** Positions for Signatures */ */
      let self = this;
      await signatureService.getPositions().then((result) => {
        self.availableSignatureOptions = result.data;
      });

      //*****signature Management********
      this.signatureList = [];
      //getting default Signatures
      let signature1 = this.getBasicSignature(1);
      if (signature1 != undefined) {
        this.signatureList.push(signature1);
      }
      let signature5 = this.getBasicSignature(5);
      if (signature5 != undefined) {
        this.signatureList.push(signature5);
      }

      let signature6 = this.getBasicSignature(4);
      if (signature6 != undefined) {
        this.signatureList.push(signature6);
      }
    },
    addSpecialistSignature() {
      let existSpecialistRow = this.signatureList.find(
        (x) =>
          !x.isRemovable &&
          x.signature.positionId &&
          x.signature.positionId.signaturePositionId == 850
      );
      if (!existSpecialistRow) {
        this.signatureCounter -= 1;
        this.signatureList.push({
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: { signaturePositionId: 850 },
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: 13,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false, //Search PositionId for specialist
          positionDisabled: true,
        });
      }
    },
    removeSpecialistSignature() {
      //this.signatureList.push(specialistSignature);
      let existSpecialistRow = this.signatureList.find(
        (x) =>
          !x.isRemovable &&
          x.signature.positionId &&
          x.signature.positionId.signaturePositionId == 850
      );
      if (existSpecialistRow) {
        this.deleteSignature(existSpecialistRow.id);
      }
    },
    async getParticipationTypeList() {
      await this.$ApiGet('/api/pei/participationTypeList')
        .then((res) => {
          this.participationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getAlternateParticipationTypeList() {
      await this.$ApiGet('/api/pei/alternateParticipationTypeList')
        .then((res) => {
          this.alternateParticipationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    //End Signatures Methods
    onEligibilityDataChanged(data) {
      this.eligibilityInfoModel = data;
      if (data.healthSpecialistParticipationFlag) {
        if (data.healthSpecialistParticipationFlag == '1') {
          this.addSpecialistSignature();
        } else {
          this.removeSpecialistSignature();
        }
      }

      this.additionalQuestionsFlag =
        this.generalEligibilityDetermination.academicYearId != null &&
        this.eligibilityInfoModel != null &&
        this.eligibilityInfoModel.eligibilityFlag == '0';

      //
    },
    async getEvaluationInfoAndAvailable(
      evaluationsAddedList,
      evaluationsExcludedList = undefined
    ) {
      await this.getEvaluationInformation(
        evaluationsAddedList,
        evaluationsExcludedList
      );
      await this.getAvailablesEvaluations();
    },
    //Section Evaluation
    async getEvaluationInformation(
      evaluationsAddedList,
      evaluationsExcludedList = undefined,
      isInitialPostRegistry,
      evaluationServiceType,
      disabled,
      evaluationDateId
    ) {
      await studentEvaluationService
        .getEvaluationForEligilibility({
          StudentSieID: this.$store.getters['$_student/StudentSie'],
          ComparisonDate: null,
          EvaluationServiceType:
            evaluationServiceType == undefined ? 2 : evaluationServiceType, // 2=additionalEvaluation enum type
          ExcludedEvaluations:
            evaluationsExcludedList != undefined
              ? evaluationsExcludedList.map((x) => x.value).join(', ')
              : '',
          SelectedEvaluations:
            evaluationsAddedList != undefined
              ? evaluationsAddedList.map((x) => x.value).join(', ')
              : '',
          evaluationDateId: evaluationDateId,
          IsInitialPostRegistry: isInitialPostRegistry,
          isDisabled: disabled,
        })
        .then((res) => {
          res.data.forEach((e) => {
            e.editable =
              e.statusId == -1 && e.isApprovedByParentFlag == null
                ? true
                : false;

            e.editable = [
              'Previa',
              'Confirmada',
              'Realizada por Remedio Provisional',
            ].includes(e.statusName);
            e.isSelectedFlag = e.isDeterminated = e.isImpedimentEvaluationFlag;
            // Y esta tonteria???
            e.isSelectedFlag = e.isApprovedByParentFlag != null;
            e.isAcceptedDisabled =
              e.isApprovedByParentFlag == null ? false : true;
            //Vm for Reject section
            e.rejection = {
              rejectionById: e.rejectionById,
              rejectionComment: e.rejectionComment,
            };
            e.isOpened = false;
          });

          let data = [...res.data];
          let uniqArray = this.$deleteArrayDuplicates(
            data,
            'studentEvaluationId'
          );

          if (
            this.evaluationInformationLayout.evaluationInformationData.length >
            0
          ) {
            const studentEvaluationsIds = this.evaluationInformationLayout.evaluationInformationData.map(
              (f) => f.studentEvaluationId
            );
            const oldData = this.evaluationInformationLayout.evaluationInformationData.map(
              (f) => f
            );
            this.evaluationInformationLayout.evaluationInformationData = uniqArray.map(
              (v) => {
                if (!studentEvaluationsIds.includes(v.studentEvaluationId)) {
                  return v;
                }
                if (
                  oldData.find(
                    (o) => o.studentEvaluationId == v.studentEvaluationId
                  ) != undefined
                ) {
                  return oldData.find(
                    (o) => o.studentEvaluationId == v.studentEvaluationId
                  );
                }
              }
            );
          } else {
            this.evaluationInformationLayout.evaluationInformationData = uniqArray.filter(
              (x) =>
                x.isApprovedByParentFlag == null ||
                evaluationsAddedList
                  .map((x) => x.value)
                  .includes(x.studentEvaluationId.toString())
            );
          }

          let selectedStudentEvaluation = [];

          this.evaluationInformationLayout.evaluationInformationData.forEach(
            (e) => {
              selectedStudentEvaluation.push(e.studentEvaluationId);
            }
          );
          this.evaluationInformationLayout.evaluationsAddedList = selectedStudentEvaluation;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    selectedEvaluationsModalSaveHandler(
      evaluationsAddedList,
      evaluationsExcludedList
    ) {
      this.getEvaluationInformation(
        evaluationsAddedList,
        evaluationsExcludedList
      );
    },
    async getAvailablesEvaluations() {
      let self = this;
      let model = {
        studentSieId: this.$store.getters['$_student/StudentSie'],
        endDate: '',
        selectedEvaluations: self.evaluationInformationLayout.evaluationsAddedList.join(
          ', '
        ),
      };
      await studentEvaluationService
        .getAvailablesEvaluations(model)
        .then((res) => {
          self.evaluationInformationLayout.availables = res.data || [];
        });
    },
    async getEvaluationAvailables(ids) {
      let self = this;
      await studentEvaluationService.getSelectedEvaluations(ids).then((res) => {
        self.evaluationInformationLayout.availables = res.data || [];
      });
    },
    //End Section Evaluation
    print() {
      if (this.generalEligibilityDetermination.changeImpediment) {
        reportService.downloadEE05(this.selectedRegStudentId, 1);
      } else {
        const model = {
          regStudentId: this.selectedRegStudentId,
          evaluationDateId: this.evaluationDateId,
          isInitial: 1,
          placementCommitteeId: this.placementCommitteeId,
        };
        reportService.downloadEE06(model);
      }
    },
  },
  computed: {
    academicYear() {
      return {
        year: this.generalEligibilityDetermination.academicYear,
        description: this.generalEligibilityDetermination.academicYearDesc,
        id: this.generalEligibilityDetermination.academicYearId,
      };
    },

    hasSelectedStudent() {
      return store.getters.IsValidSelectedStudent;
    },
    userHasCreateAccess() {
      return true;
    },
    fromRoute() {
      return this.$router.app._route.params;
    },
    selectedStudent() {
      return this.$store.getters.SelectedStudent;
    },
    selectedStudentSieId() {
      return this.selectedStudent.studentId;
    },
    hasEvaluationSelected() {
      return this.evaluationInformationLayout.evaluationInformationData.some(
        (x) => x.isSelectedFlag
      );
    },
    hasInvalidSelectedEvaluation() {
      return this.evaluationInformationLayout.evaluationInformationData.some(
        (x) => x.isSelectedFlag && x.isApprovedByParentFlag == null
      );
    },
    existInvalidEvaluationReject() {
      return this.evaluationInformationLayout.evaluationInformationData.some(
        (x) =>
          x.isSelectedFlag &&
          x.isApprovedByParentFlag == false &&
          (x.rejection.rejectionById == null ||
            x.rejection.rejectionComment == null ||
            x.rejection.rejectionComment == '')
      );
    },
    allEvaluationsApprovedOrRejected() {
      return this.evaluationInformationLayout.evaluationInformationData.every(
        (x) => x.isSelectedFlag
      );
    },
    selectedRegStudentId() {
      return this.selectedStudent.regStudentId;
    },
  },
};
</script>

<style scope>
form {
  width: 100%;
}
</style>
<style src="@/assets/css/component/radio-button.css"></style>
<style src="@/assets/css/component/datepicker.css"></style>
<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>
<style src="@/assets/css/component/messages.css"></style>

<style scoped>
.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}

.mv {
  margin-right: 1.75%;
}
</style>
